module.exports = __webpack_public_path__ + "static/media/PK.36d77afc.png";